<template>
  <div class="flex items-center justify-between">
    <span
      class="inline-flex items-center leading-none border border-solid"
      :class="[
        statusStyle.bg, statusStyle.text, statusStyle.border,
        isPC ? 'rounded-[20px] px-[16px] h-[40px] text-[20px]' : 'rounded-[24px] px-[20px] h-[48px] text-[24px]',
      ]"
    >
      <span
        class="rounded-full"
        :class="[statusStyle.dot, isPC ? 'mr-[4px] h-[5px] w-[5px]' : 'mr-[5px] h-[6px] w-[6px]']"
      ></span>
      {{ statusText }}
    </span>

    <span
      v-if="showParticipant"
      class="flex items-center text-[#7a7a7a] text-[24px]"
    >
      <img
        src="../images/icon-people.png"
        :class="isPC ? 'mr-[5px] w-[24px] h-[24px]' : 'mr-[4px] w-[28px] h-[28px]'"
      />
      {{ participantCount }}{{ participantCount <= 1 ? $t('participantUnit') : $t('participantUnits') }}
    </span>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { use as fegoUse } from '@fegobull/webapi';
import { useFegoPageInfo } from '@ark/web-shared/use';
import { PREDICT_STATUS, type PredictStatus } from '../../shared/types';
import locales from '../locales';
const __sfc_main = {};
__sfc_main.props = {
  status: {
    key: "status",
    required: true,
    type: null
  },
  participantCount: {
    key: "participantCount",
    required: true,
    type: Number
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    useI18n
  } = fegoUse;
  const $t = useI18n(locales);
  const {
    isPC
  } = useFegoPageInfo();
  const STATUS_STYLE: Record<PredictStatus, {
    text: string;
    bg: string;
    dot: string;
    border: string;
  }> = {
    upcoming: {
      text: 'text-[#327FFF]',
      bg: 'bg-[#F2F3FF]',
      dot: 'bg-[#327FFF]',
      border: 'border-[#327FFF]'
    },
    ongoing: {
      text: 'text-[#FF6900]',
      bg: 'bg-[#FFF5EE]',
      dot: 'bg-[#FF6900]',
      border: 'border-[#FF6900]'
    },
    closed: {
      text: 'text-[#262626]',
      bg: 'bg-[#F4F4F4]',
      dot: 'bg-[#262626]',
      border: 'border-[#262626]'
    },
    settling: {
      text: 'text-[#262626]',
      bg: 'bg-[#F4F4F4]',
      dot: 'bg-[#262626]',
      border: 'border-[#262626]'
    },
    settled: {
      text: 'text-[#7a7a7a]',
      bg: 'bg-[#F4F4F4]',
      dot: 'bg-[#7a7a7a]',
      border: 'border-[#7a7a7a]'
    }
  };
  const statusText = computed(() => $t(props.status));
  const statusStyle = computed(() => STATUS_STYLE[props.status]);
  /** 未开始（upcoming）时隐藏参与人数 */
  const showParticipant = computed(() => props.status !== PREDICT_STATUS.UPCOMING);
  return {
    $t,
    isPC,
    statusText,
    statusStyle,
    showParticipant
  };
};
export default __sfc_main;
</script>
